import { lazyWithRetry } from '../../utils/lazy-with-retry';

const Pricing = lazyWithRetry(() => import('./pricing'), 'Pricing');
const TrialExpired = lazyWithRetry(() => import('./trial-expired'), 'TrialExpired');
const CodeRedemption = lazyWithRetry(() => import('./code-redemption'), 'CodeRedemption');
const TrialExpiredModal = lazyWithRetry(() => import('./trial-expired-analytics'), 'TrialExpiredModal');
const PlanExpired = lazyWithRetry(() => import('./plan-expired'), 'PlanExpired');

export {
  Pricing,
  TrialExpired,
  CodeRedemption,
  TrialExpiredModal,
  PlanExpired,
};
